import { API_BASE_URL } from "../config/api";

/** Public preview of a shared challenge (no login). Resolves to { state, ... } or throws with .status 404. */
export async function getPublicChallenge(code) {
  if (!API_BASE_URL) throw new Error("API base URL is not configured.");

  const response = await fetch(`${API_BASE_URL}/public/challenges/${encodeURIComponent(code)}`);
  const body = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw Object.assign(new Error(body.message || "Challenge not found"), { status: response.status });
  }

  return body.data;
}
